<div class="pivot-auto-complete">
  <p-autoComplete [ngClass]="{'disabled' : disabled, 'error' : (inputParams.isError? inputParams.isError:false)}" [(ngModel)]="selectedData" [suggestions]="filteredData"
    (completeMethod)="filterData($event)" [field]="field" [multiple]="true" (onUnselect)="unselectData($event)"
    [required]="required"
    (ngModelChange)="dataChange($event)" [disabled]="disabled" [maxlength]="maxLengthValue">
  </p-autoComplete>
  <label *ngIf="(inputParams.isError? inputParams.isError:false)"
  class="pivot-validate-err">{{inputParams.validateError}}</label>
</div>